import React from "react";
import {observer} from "mobx-react-lite";
import {Grid} from "@mui/material";
import {MithraEchart} from "../../../services/echarts/MithraEchart";
import {useSitStores} from "../../../stores";
import type {EChartContextType} from "../../../services/echarts/EChartProvider";
import type {EChartsType} from "echarts/types/dist/shared";
import {EchartSitDefaultColor, EchartSitDefaultLegend, sitAxisNumberFormatter} from "../../../services/echarts/EchartSitCommonConfig";
import {SIT_TEST} from "../../SitApit";
import i18n from "../../../i18n/i18n";

const fin = (k: string) => i18n.t(`fin.${k}`, {ns: 'sit'});

function init(echart: EChartContextType, root: HTMLElement, data: any[]): EChartsType {
    const chart = echart.init(root, 'mithra', {renderer: 'svg', height: 200});
    chart.setOption({
        tooltip: {
            trigger: 'axis',
        },
        toolbox: {
            show: true,
            feature: {
                saveAsImage: {show: true},
            },
        },
        legend: {
            data: [fin('approved'), fin('pending')],
            ...EchartSitDefaultLegend
        },
        color: EchartSitDefaultColor,
        grid: {left: 8, right: 16, top: 40, bottom: 8, containLabel: true},
        xAxis: {type: 'value', axisLabel: {formatter: sitAxisNumberFormatter}},
        yAxis: {type: 'category'},
        dataset: data,
        series: [
            {
                name: fin('approved'),
                type: 'bar',
                encode: {x: 'Amount', y: 'Type'},
                datasetId: 'DOI5 total aggregated approved saving and target',
                stack: 'Totals',
                color: '#091344',
            },
            {
                name: fin('pending'),
                type: 'bar',
                encode: {x: 'Amount', y: 'Type'},
                datasetId: 'DOI5 total aggregated pending saving and target ',
                stack: 'Totals',
                color: '#ff3435',
            }
        ],
    })
    return chart;
}

export const TargetVsActualVertical: React.FC = observer(() => {
    const {fbStore} = useSitStores();

    const data = [
        {
            id: 'DOI5 total aggregated approved saving and target',
            dimensions: [
                {name: 'Type'},
                {name: 'Amount', type: 'number'},
            ],
            source: [
                [
                    fin('saving'),
                    fbStore.approvedContribution,
                ],
                [
                    fin('target'),
                    fbStore.totalTargetOfYear,
                ],
            ]
        },
        {
            id: 'DOI5 total aggregated pending saving and target ',
            dimensions: [
                {name: 'Type'},
                {name: 'Amount', type: 'number'},
            ],
            source: [
                [
                    fin('saving'),
                    fbStore.notApprovedContribution,
                ],
                [
                    fin('target'),
                    0,
                ],
            ]
        },
    ]

    return (
        <Grid container>
            <Grid size={12}>
                {SIT_TEST && '<TargetVsActualVertical/>'}
                <MithraEchart
                    // alwaysRerender={() => {
                    // }}
                    initChart={init}
                    data={data}
                    autoUpdateDataset
                    loading={fbStore.busy}
                />
            </Grid>
        </Grid>
    );
})